import React from "react";

import LoginForm from "../components/LoginForm";
import GenerateCategories from "../GenerateCategories";



const LoginPage = () => {
  return (
    <div>
      {/* <GenerateCategories/> */}
      <LoginForm/>
    </div>
  );
};

export default LoginPage;
